const hideModal = (elementId) => {
  const modal = bootstrap.Modal.getOrCreateInstance(
    document.getElementById(elementId)
  );
  modal.hide();
};

export default hideModal;
